import { z } from "zod";
import { ArticleCardCarouselContractSchema } from "./ArticleCardCarousel";
import { ArticleCardGridContractSchema } from "./ArticleCardGrid";
import { ArticleMastheadContractSchema } from "./ArticleMasthead";
import { ArticleMediaCarouselContractSchema } from "./ArticleMediaCarousel";
import { ArticleMediaEmbedContractSchema, } from "./ArticleMediaEmbed/components/ArticleMediaEmbed";
import { ArticleMediaGalleryContractSchema } from "./ArticleMediaGallery";
import { ArticlePromoCardGridContractSchema } from "./ArticlePromoCardGrid";
import { ArticleRichTextAccordionContractSchema, } from "./ArticleRichTextAccordion/components/ArticleRichTextAccordion";
import { ArticleRichTextBladeContractSchema } from "./ArticleRichText/";
import { AssetHighlightContractSchema } from "./AssetHighlight";
import { AudioPlayerContractSchema } from "./AudioPlayer";
import { ChooseFighterContractSchema } from "./ChooseFighter";
import { EmailSubscribeContractSchema } from "./EmailSubscribe";
import { FeaturedNewsCarouselContractSchema } from "./FeaturedNewsCarousel";
import { FullWidthImageContractSchema } from "./FullWidthImage";
import { GameDetailMastheadContractSchema } from "./GameDetailMasthead";
import { GameSpecsContractSchema } from "./GameSpecs";
import { ImageCarouselContractSchema } from "./ImageCarousel";
import { LandingMediaEmbedContractSchema } from "./LandingMediaEmbed";
import { LandingRichTextAccordionContractSchema, } from "./LandingRichTextAccordion/components/LandingRichTextAccordion";
import { LandingPromoCardCarouselContractSchema } from "./LandingPromoCardCarousel";
import { LandingRichTextBladeContractSchema } from "./LandingRichText/";
import { MediaPromoBladeContractSchema } from "./MediaPromo/components/MediaPromoBlade";
import { SeparatorContractSchema } from "./Separator/components/Separator";
import { TickerBannerContractSchema } from "./TickerBanner";
import { RiotBarContractSchema } from "./RiotBar";
import { GameBetaMastheadContractSchema } from "./GameBetaMasthead";
import { GameSimpleMastheadContractSchema } from "./GameSimpleMasthead";
import { CenteredPromotionContractSchema } from "./CenteredPromotion";
import { CenterPromoMastheadContractSchema } from "./CenterPromoMasthead";
import { PatchNotesRichTextBladeContractSchema } from "./PatchNotesRichText";
import { BetaRegistrationMastheadContractSchema, } from "../custom/betaExperience/blades/BetaRegistrationMasthead";
import { BetaCenteredMastheadContractSchema, } from "../custom/betaExperience/blades/BetaCenteredMasthead";
import { BetaSuccessMastheadContractSchema, } from "../custom/betaExperience/blades/BetaSuccessMasthead";
import { BetaConnectConsoleMastheadContractSchema, } from "../custom/betaExperience/blades/BetaConnectConsoleMasthead";
import { BetaKeyDisplayMastheadContractSchema, } from "../custom/betaExperience/blades/BetaKeyDisplayMasthead";
import { TextMastheadContractSchema } from "./TextMasthead";
import { CharacterCardGridContractSchema } from "./CharacterCardGrid";
import { MediaMastheadContractSchema } from "./MediaMasthead";
import { CharacterChangesBladeContractSchema } from "./CharacterChanges";
import { CharacterMastheadBladeContractSchema } from "./CharacterMasthead";
import { BetaInviteMediaPromoContractSchema, } from "../custom/betaExperience/blades/BetaInviteMediaPromo";
import { IconTabContractSchema } from "./IconTab/components/IconTab";
import { LandingMediaCarouselContractSchema } from "./LandingMediaCarousel";
import { PlatformSelectionMastheadBladeContractSchema, } from "./PlatformSelectionMasthead";
export const AllBladeContractsSchema = z.discriminatedUnion("type", [
    ArticleCardCarouselContractSchema,
    ArticleCardGridContractSchema,
    ArticleMastheadContractSchema,
    ArticleMediaCarouselContractSchema,
    ArticleMediaGalleryContractSchema,
    ArticleMediaEmbedContractSchema,
    ArticlePromoCardGridContractSchema,
    ArticleRichTextAccordionContractSchema,
    ArticleRichTextBladeContractSchema,
    AssetHighlightContractSchema,
    AudioPlayerContractSchema,
    BetaCenteredMastheadContractSchema,
    BetaConnectConsoleMastheadContractSchema,
    BetaInviteMediaPromoContractSchema,
    BetaKeyDisplayMastheadContractSchema,
    BetaRegistrationMastheadContractSchema,
    BetaSuccessMastheadContractSchema,
    CenteredPromotionContractSchema,
    CenterPromoMastheadContractSchema,
    CharacterCardGridContractSchema,
    CharacterChangesBladeContractSchema,
    CharacterMastheadBladeContractSchema,
    ChooseFighterContractSchema,
    EmailSubscribeContractSchema,
    FeaturedNewsCarouselContractSchema,
    FullWidthImageContractSchema,
    GameBetaMastheadContractSchema,
    GameDetailMastheadContractSchema,
    GameSimpleMastheadContractSchema,
    GameSpecsContractSchema,
    IconTabContractSchema,
    ImageCarouselContractSchema,
    LandingMediaCarouselContractSchema,
    LandingMediaEmbedContractSchema,
    LandingRichTextAccordionContractSchema,
    LandingRichTextBladeContractSchema,
    LandingPromoCardCarouselContractSchema,
    MediaMastheadContractSchema,
    MediaPromoBladeContractSchema,
    PatchNotesRichTextBladeContractSchema,
    PlatformSelectionMastheadBladeContractSchema,
    RiotBarContractSchema,
    SeparatorContractSchema,
    TickerBannerContractSchema,
    TextMastheadContractSchema,
]);
//# sourceMappingURL=index.js.map